import type { FaireProductEntity } from "../../entity_types/product";

export const p_2r9vcx9g7p: FaireProductEntity = {
  token: "p_2r9vcx9g7p",
  type: "product",
  name: "Swedish Dream Gnome Foam Swedish Pine",
  brandToken: "b_ddmhdunv",
  brandName: "Kalastyle Soap Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/9f9643de5d9e70b4deccdd4c1012c1d4697addd5f52d02c1f7191066391f0406.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bbbb4a1839c35d901a72e58b68e6b8a642c72ff30a942f75bb8298c40ec8435c.jpeg",
    "https://cdn.faire.com/fastly/307d0e5c5271a027705dc84371c697fdd8ea0228d4065b867857d6c68bfba92e.jpeg",
    "https://cdn.faire.com/fastly/bad81cfcd0fc3ef0548d2ddeda7dfb1647e9986e0b9172056f07ea9029f25d4d.jpeg",
  ],
  priceDollars: 5,
  description:
    "Draw a warm bath and drop in some magic! Formulated with skin-friendly ingredients and twice the size of the average bath bomb, these nourishing Gnome Foams work to hydrate and replenish dry skin, leaving it feeling soft and supple.  Up to 10 minutes of foaming!\n\nInvite a sense of comfort & ease as you breathe in the feel-good aromas of fresh Swedish Pine and calming Organic Eucalyptus Oil. Place the Gnome Foam directly under a running faucet for next-level foaming.\n\nEach bath bomb is individually hand-wrapped in recycled paper that is compost-friendly. ",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:15.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
